export default __webpack_public_path__ + "static/media/package4.149a1fab.png";